import axios from 'axios';
import {isEmptyOrNull} from './utility';
import config from './config';
import safeStorage, { safeSessionStorage } from './safeStorage';
import { trustedPanelHost } from './apiHost';
import { API_TIMEOUT_MS } from './requestConfig';
import { logRequestFailure } from './logRequestFailure';

// Both helpers run while the app starts: blocked storage or a stale `panel` cookie must cost the
// cover image or one statistic, never the whole portal (CO-BOOTSTRAP-RAW-STORAGE,
// CO-COVER-STARTUP-HOST).
    const getLink = () => {
        const cached = safeStorage.getItem('coverPhoto');
        if(cached){
            return cached
        }
        let coverUrl;
        try {
            coverUrl = `${config.generateUrl(trustedPanelHost())}/tgm-api/cover`;
        } catch (error) {
            console.error('Fetching CoverImg - ', error);
            return;
        }
        axios.get(coverUrl, { responseType:"blob", timeout: API_TIMEOUT_MS })
        .then((response)=> {
            var reader = new window.FileReader();
            reader.readAsDataURL(response.data); 
            reader.onload =()=> {
                safeStorage.setItem('coverPhoto',reader.result)
                return reader.result
            }
        }).catch(error => {
            logRequestFailure('Fetching CoverImg - ', error);
        });
    };

    // Once per browser tab session (CO-PWA-STAT-RENDER): App asks whenever a session appears, the
    // server needs to hear it once. The module flag covers a tab whose sessionStorage is blocked.
    // A failed attempt releases the flag, so the next start of the app tries again.
    const PWA_STAT_SENT_KEY = 'pwa-stat-sent';
    let pwaStatSent = false;

    const setPwaStatistics = () => {
        if (pwaStatSent || safeSessionStorage.getItem(PWA_STAT_SENT_KEY) === '1') return;
        if (window.matchMedia('(display-mode: standalone)').matches) {
            const requestConfig = {
                timeout: API_TIMEOUT_MS,
                headers: {
                    "content-type": "multipart/form-data",
                    "Authorization": `Bearer ${safeStorage.getItem('auth_token')}`
                },
            };

            let url = null;
            try {
                url = `${config.generateUrl(trustedPanelHost())}/tgm-api/stat`;
            } catch (error) {
                console.warn('PWA status save error ', error);
            }
            if(!isEmptyOrNull(url)) {
                pwaStatSent = true;
                safeSessionStorage.setItem(PWA_STAT_SENT_KEY, '1');
                const release = () => {
                    pwaStatSent = false;
                    safeSessionStorage.removeItem(PWA_STAT_SENT_KEY);
                };
                axios.post(url,{'pwa' : 1},requestConfig).then(res => {
                    if (!!res && res.status >= 200 && res.status < 300) {
                        console.log('SUCCESS: PWA status saved to server');
                    } else {
                        release();
                    }
                }, err => {
                    release();
                    logRequestFailure('PWA status save Failed ', err, 'warn');
                }).catch((err) => {
                    logRequestFailure('PWA status save error ', err, 'warn');
                });
            }
        }
    };

export {getLink, setPwaStatistics};
